import { Route, Switch } from "react-router-dom";
import VendorLoginCtrl from "../../vendor/Login/VendorLoginCtrl";
import VendorForgetPassword from "../../vendor/Login/VendorForgetPassword";
import VendorSetPasswordState from "../../vendor/Login/VendorSetPassword";
import LoginCtrl from "../../Client/Login/loginCtrl";
import ForgotLoginIdScreen from "../../../components/login/loginScreen/forgotLoginIdScreen";
import ForgotPasswordScreen from "../../../components/login/loginScreen/forgotPasswordScreen";
import UnblockAccountScreen from "../../../components/login/loginScreen/unblockAccScreen";
import LoginHelp from "../../../components/login/loginScreen/loginHelp";
import { RoutesUrl } from "../constents";

const LoginRoutes = () => {
  return (
    <Switch>
      <Route exact path={RoutesUrl.VendorLogin} component={VendorLoginCtrl} />
      <Route
        exact
        path={RoutesUrl.VendorForgetPassword}
        component={VendorForgetPassword}
      />
      <Route
        exact
        path={RoutesUrl.VendorSetPassword}
        component={VendorSetPasswordState}
      />
      <Route exact path={RoutesUrl.ClientLogin} component={LoginCtrl} />
      <Route exact path={RoutesUrl.LoginHelp} component={LoginHelp} />
      <Route
        exact
        path={RoutesUrl.ClientForgotLoginId}
        component={ForgotLoginIdScreen}
      />
      <Route
        exact
        path={RoutesUrl.ClientForgotPassword}
        component={ForgotPasswordScreen}
      />
      <Route
        exact
        path={RoutesUrl.ClientUnblockAccount}
        component={UnblockAccountScreen}
      />
      {/* <Route exact path={RoutesUrl.ClientForgotYOB} component={ForgotScreen} /> */}
    </Switch>
  );
};
export default LoginRoutes;
